export default {"src":"/_next/static/media/Minimally Invasive Techniques.f255915f.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};